import React from 'react';
import PropTypes from 'prop-types';
import AppFooter from '../AppFooter';
import { AppHeader } from '../../public/AppHeader';

export function PublicLayout({ children }) {
  return (
    <>
      <AppHeader />
      {children}
      <AppFooter />
    </>
  );
}

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
